<script>
import _ from 'lodash'
import service from '@/request/base'
import ImageService from '@/request/file/image'
export default {
  name: 'DatabankNormcaseParagraphEdit',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    imageMark: {
      type: String,
      default: '医步助手'
    }
  },
  data () {
    return {
      paragraph: {},
      percentage: 0,
      uploading: false
    }
  },
  computed: {},
  created: function () {
    this.init()
  },
  mounted: function () {},
  beforeDestroy () {},
  watch: {
    value () {
      this.init()
    },
    percentage (val) {
      if (val && val > 0) {
        this.uploading = true
      }
      if (val >= 100 && this.uploading) {
        let self = this
        setTimeout(() => {
          self.percentage = 0
          self.uploading = false
        }, 1000)
      }
    },
    paragraph: {
      deep: true,
      handler () {
        this.updateData()
      }
    }
  },
  methods: {
    updateData () {
      if (_.isEqual(this.value, this.paragraph)) {
        return
      }
      this.$emit('input', this.paragraph)
    },
    init () {
      this.paragraph = _.clone(this.value || {})
    },
    handleBeforeUpload (file) {
      let type = file.type
      if (!type) {
        this.$message.error('文件:' + file.name + '的类型不正确')
        return false
      }
      if (type.indexOf('image/') !== 0 && type.indexOf('video/') !== 0) {
        this.$message.error('不支持文件:' + file.name + '的类型')
        return false
      }
      return true
    },
    uploadFile (options) {
      return new Promise((resolve, reject) => {
        let type = options.file.type
        if (type.indexOf('image/') === 0) {
          ImageService.uploadImage(options.file, this.imageMark, 'super', options.onProgress).then(uimg => {
            uimg = uimg.result
            if (!uimg) {
              reject(new Error('上传图片失败'))
            } else {
              resolve({
                type: 'image',
                data: uimg
              })
            }
          }).catch(error => {
            reject(error || new Error('上传图片失败'))
          })
        } else if (type.indexOf('video/') === 0) {
          ImageService.uploadVideo(options.file, options.onProgress).then(uvideo => {
            uvideo = uvideo.result
            if (!uvideo) {
              reject(new Error('上传视频失败'))
            } else {
              resolve({
                type: 'video',
                data: uvideo
              })
            }
          }).catch(error => {
            reject(error || new Error('上传视频失败'))
          })
        } else {
          reject(new Error('不支持的文件类型'))
        }
      })
    },
    handleProgress (event) {
      this.percentage = parseInt(event.percent, 10)
    },
    handleUploadImageSuccess (data) {
      let par = _.cloneDeep(this.paragraph)
      let type = data.type || 'image'
      data = data.data
      let thumbnail = type === 'image' ? data.small : data.cover
      let image = type === 'image' ? data.superSrc : data.location
      _.assign(par, {
        thumbnail: thumbnail,
        image: image,
        width: data.width || 1024,
        height: data.height || 768
      })
      this.paragraph = _.cloneDeep(par)
    },
    finishEdit (event) {
      event.stopPropagation()
      this.$emit('click-finish', this.data)
    },
    delImage (event) {
      event.stopPropagation()
      this.$confirm('确定删除图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = _.cloneDeep(this.paragraph)
        _.assign(data, {
          thumbnail: null,
          image: null,
          width: null,
          height: null
        })
        this.paragraph = _.cloneDeep(data)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    },
    isImage (url) {
      let type = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
      return _.indexOf(['jpg', 'jpeg', 'png', 'bmp'], type) >= 0
    }
  },
  filters: {
    imageFilter (value) {
      return service.url(value)
    }
  }
}
</script>

<template>
  <div class="edit-paragraph-content">
    <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
      <div class="header">
        <div class="left">
          <el-upload
            action="upload"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :http-request="uploadFile"
            :on-success="handleUploadImageSuccess"
            :on-progress="handleProgress">
            <el-button size="small">
              <span v-if="paragraph.image">更换图片</span>
              <span v-else>添加图片</span>
            </el-button>
          </el-upload>
        </div>
        <div class="title">编辑段落</div>
        <div class="right"><el-button size="small" @click="finishEdit($event)">完 成</el-button></div>
        <div class="progress" v-if="uploading">
          <el-progress :percentage="percentage" :status="percentage >= 100 ? 'success' : null"></el-progress>
        </div>
      </div>
      <div class="image" v-if="paragraph.image">
        <div class="image-wrap">
          <img v-if="isImage(paragraph.image)" :src="paragraph.image | imageFilter">
          <video v-else :src="paragraph.image | imageFilter" width="100%" height="100%" controls>您的浏览器不支持播放视频</video>
        </div>
        <a href="javascript:void(0)" @click="delImage($event)" class="del-icon"><i class="el-icon-delete"></i></a>
      </div>
      <el-form ref="paragraphForm" :model="paragraph">
        <el-form-item>
          <el-input type="textarea" :autosize="{ minRows: 12, maxRows: 12 }" v-model="paragraph.remark" placeholder="请输入段落文字"></el-input>
        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.edit-paragraph-content {
  width: 100%;
  height: 100%;
}
.header {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  position: relative;
}
.header .title {
  width: 100%;
  text-align: center;
  line-height: 32px;
  font-size: 22px;
}
.header .left {
  position: absolute;
  top: 0;
  left: 0;
}
.header .right {
  position: absolute;
  top: 0;
  right: 0;
}
.header .progress {
  width: 100%;
  padding: 0 20px 0 10px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  position: absolute;
  bottom: -20px;
}
.image {
  width: 100%;
  height: 225px;
  position: relative;
  margin-bottom: 20px;
  padding: 0 15px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
.image-wrap {
  position: relative;
  width: 100%;
  height: 100%;
}
.image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: block;
  margin: auto;
  padding: auto;
}
.image .del-icon {
  position: absolute;
  bottom: 0;
  right: 5px;
  color: #FF0000;
  font-weight: 400;
  font-size: 20px;
}
</style>
